import { Box, Stack, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

type APIDefinitionProps = {
  type?: string;
  definitions: {
    getTitle: (t: TFunction<'ns1'>) => string;
    getDescription: (t: TFunction<'ns1'>) => string;
  }[];
};

const APIDefinitions = ({ type, definitions }: APIDefinitionProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      {type && <Typography variant="h2">{type}</Typography>}
      <Stack spacing={0.5}>
        {definitions.map(({ getTitle, getDescription }) => {
          const title = getTitle(t);
          return (
            <div key={title}>
              <Typography
                component="span"
                fontWeight="bold"
                sx={{ textDecoration: 'underline' }}
              >
                {title}
              </Typography>{' '}
              -{' '}
              <Typography
                component="span"
                dangerouslySetInnerHTML={{ __html: getDescription(t) }}
                sx={{
                  '& a': {
                    color: 'primary.main',
                  },
                }}
              />
            </div>
          );
        })}
      </Stack>
    </Box>
  );
};

export default APIDefinitions;
